import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ContestIcon from "../assets/contest.svg";
import ContestWhiteIcon from "../assets/contest-white.svg";
import FeedbackIcon from "@mui/icons-material/Feedback";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PaletteIcon from "@mui/icons-material/Palette";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import MicIcon from "@mui/icons-material/Mic";
import BoltIcon from "@mui/icons-material/Bolt";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import InsightsIcon from "@mui/icons-material/Insights";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import GavelIcon from "@mui/icons-material/Gavel";
import SecurityIcon from "@mui/icons-material/Security";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import routePaths from "../router/route-paths";

/**
 * Grouped sidebar navigation config.
 * Groups with zero permitted items are hidden after role filtering.
 */
export const sidebarGroups = [
  {
    id: "overview",
    label: "Overview",
    items: [
      {
        label: "Dashboard",
        path: routePaths.DASHBOARD,
        image: DashboardCustomizeIcon,
      },
      {
        label: "Calendar",
        path: routePaths.CALENDAR,
        image: CalendarMonthIcon,
      },
      {
        label: "Analytics",
        path: routePaths.REPORTS,
        image: InsightsIcon,
      },
      {
        label: "Sales",
        path: routePaths.SALES,
        image: PointOfSaleIcon,
      },
      {
        label: "Mobile",
        path: routePaths.MOBILE,
        image: PhoneIphoneIcon,
      },
    ],
  },
  {
    id: "users",
    label: "Users",
    items: [
      {
        label: "Users",
        path: routePaths.MANAGE_USERS,
        image: ManageAccountsOutlinedIcon,
      },
      {
        label: "Account Tools",
        path: routePaths.USER_MODIFICATION,
        image: ManageAccountsIcon,
      },
      {
        label: "Curated Matches",
        path: routePaths.CURATED_MATCHES,
        image: EmojiEventsIcon,
      },
    ],
  },
  {
    id: "content",
    label: "Content",
    items: [
      {
        label: "Audio",
        path: routePaths.MANAGE_AUDIO,
        image: AudioFileIcon,
      },
      {
        label: "Karaoke",
        path: routePaths.MANAGE_KARAOKE,
        image: MicIcon,
      },
      {
        label: "Dance",
        path: routePaths.MANAGE_DANCE,
        image: DirectionsRunIcon,
      },
      {
        label: "Rap",
        path: routePaths.MANAGE_RAP,
        image: MusicNoteIcon,
      },
      {
        label: "Categories",
        path: routePaths.MANAGE_CATEGORY,
        image: PersonAddIcon,
      },
    ],
  },
  {
    id: "engagement",
    label: "Engagement",
    items: [
      {
        label: "Challenges",
        path: routePaths.MANAGE_CHALLENGE,
        image: AssignmentTurnedInIcon,
      },
      {
        label: "Contests",
        path: routePaths.MANAGE_CONTESTS,
        image: ContestIcon,
        whiteImage: ContestWhiteIcon,
        customIcon: true,
      },
      {
        label: "Themes",
        path: routePaths.MANAGE_THEME,
        image: PaletteIcon,
      },
      {
        label: "Naming Polls",
        path: routePaths.MANAGE_POLLS,
        image: HowToVoteIcon,
      },
      {
        label: "Badges",
        path: routePaths.MANAGE_BADGE,
        image: AdminPanelSettingsIcon,
      },
    ],
  },
  {
    id: "support",
    label: "Support",
    items: [
      {
        label: "Reports",
        path: routePaths.MANAGE_TICKET,
        image: ConfirmationNumberIcon,
      },
      {
        label: "Appeals",
        path: routePaths.MANAGE_APPEALS,
        image: GavelIcon,
      },
      {
        label: "Anti-Cheat",
        path: routePaths.ANTI_CHEAT,
        image: SecurityIcon,
      },
      {
        label: "Feedback",
        path: routePaths.MANAGE_FEEDBACK,
        image: FeedbackIcon,
      },
      {
        label: "FAQs",
        path: routePaths.MANAGE_FAQ,
        image: HelpOutlineIcon,
      },
    ],
  },
  {
    id: "notifications",
    label: "Notifications",
    items: [
      {
        label: "Notifications",
        path: routePaths.MANAGE_NOTIFICATIONS,
        image: NotificationsIcon,
      },
      {
        label: "Messages",
        path: routePaths.MANAGE_MESSAGES,
        image: MailOutlineIcon,
      },
      {
        label: "Patch Updates",
        path: routePaths.MANAGE_PATCH_UPDATES,
        image: SystemUpdateAltIcon,
      },
      {
        label: "@pagent Posts",
        path: routePaths.MANAGE_PAGENT_POSTS,
        image: PhotoCameraBackIcon,
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    items: [
      {
        label: "Admin Settings",
        path: routePaths.MANAGE_ADMIN_SETTINGS,
        image: SettingsApplicationsIcon,
      },
      {
        label: "Admin Accounts",
        path: routePaths.MANAGE_ADMIN_ACCOUNTS,
        image: SupervisorAccountIcon,
      },
      {
        label: "Match & Energy",
        path: routePaths.MANAGE_GAMEPLAY_SETTINGS,
        image: BoltIcon,
      },
      {
        label: "Film VS Feed",
        path: routePaths.FILM_FEED,
        image: VideocamOutlinedIcon,
      },
      {
        label: "Face Verification",
        path: routePaths.MANAGE_FACE_VERIFICATION,
        image: FaceRetouchingNaturalIcon,
      },
      {
        label: "Seasons",
        path: routePaths.MANAGE_SEASON,
        image: EventRepeatIcon,
      },
      {
        label: "Profile Settings",
        path: routePaths.PROFILE_SETTINGS,
        image: ManageAccountsIcon,
      },
    ],
  },
];

/** Flat list of all nav items (for dashboards / quick links). */
export const allSidebarItems = sidebarGroups.flatMap((group) => group.items);
